import {
    requestGet, requestPost, hGet, hPost,
} from '@osgfe/tools';

export default {
    install(Vue) {
        Vue.prototype.$get = requestGet;
        Vue.prototype.$post = requestPost;
        Vue.prototype.$hGet = hGet;
        Vue.prototype.$hPost = hPost;
    },
};
